/* FORMR theme script */
(function(){
"use strict";
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const F=window.FORMR||{};
const money=c=>(c/100).toLocaleString('en-AU',{style:'currency',currency:F.currency||'AUD',minimumFractionDigits:c%100?2:0});
function p4(c){ if(!c) return ''; if(c<=(F.pay4Max||200000)) return 'or 4 payments of <b>'+money(Math.floor(c/4))+'</b> '+(F.pay4Text||''); return 'Ask us about payment plans on larger pieces'; }
/* ---------- palettes for generated sculpture art ---------- */
const PAL = {
  burgundy:{h:348,s:58,l:28,k:'gloss',sw:'#7A2234',name:'Burgundy'},
  chrome:{h:220,s:4,l:62,k:'chrome',sw:'linear-gradient(135deg,#f4f4f4,#8d8d92 45%,#e9e9ea 60%,#59595e)',name:'Chrome & silver'},
  greige:{h:30,s:13,l:74,k:'matte',sw:'#C9BCB0',name:'Greige & beige'},
  pink:{h:342,s:62,l:72,k:'frost',sw:'#E7A3B6',name:'Frost pink'},
  black:{h:330,s:6,l:13,k:'gloss',sw:'#1E1A1B',name:'Black'},
  white:{h:30,s:12,l:91,k:'matte',sw:'#F3EFEA',name:'White'},
  bronze:{h:26,s:38,l:40,k:'frost',sw:'#8A5A3B',name:'Bronze & brown'},
  gold:{h:42,s:58,l:52,k:'metal',sw:'linear-gradient(135deg,#f6e3a1,#b8892e 50%,#f0d384)',name:'Gold'},
  seafoam:{h:165,s:24,l:70,k:'gloss',sw:'#9FC7BA',name:'Seafoam'},
  terracotta:{h:16,s:50,l:47,k:'matte',sw:'#B5583B',name:'Terracotta'}
};
const SWATCH_ORDER = ['burgundy','chrome','greige','pink','black','white','bronze','gold','seafoam','terracotta'];

const hsl=(h,s,l,a=1)=>`hsla(${h},${s}%,${Math.max(2,Math.min(98,l))}%,${a})`;
/* ---------- utilities ---------- */
function rng(seed){let a=seed*2654435761>>>0;return()=>{a|=0;a=a+0x6D2B79F5|0;let t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
/* ---------- generated sculpture art ---------- */
function drawArt(cv){
  const a = JSON.parse(cv.dataset.a||'{}');
  const r = cv.getBoundingClientRect(); const w=Math.round(r.width), h=Math.round(r.height);
  if(w<4||h<4) return false;
  const dpr = Math.min(2, devicePixelRatio||1);
  cv.width=w*dpr; cv.height=h*dpr;
  const c=cv.getContext('2d'); c.setTransform(dpr,0,0,dpr,0,0);
  const R=rng(a.seed||1), pal=PAL[a.pal]||PAL.greige;
  // wall
  const g=c.createLinearGradient(0,0,w*.3,h);
  if(a.dark){g.addColorStop(0,'#2E2628');g.addColorStop(1,'#171213')}else{g.addColorStop(0,'#EEE9E5');g.addColorStop(1,'#D9D1CB')}
  c.fillStyle=g;c.fillRect(0,0,w,h);
  const lg=c.createRadialGradient(w*.25,h*.15,0,w*.25,h*.15,Math.max(w,h));
  lg.addColorStop(0,a.dark?'rgba(255,230,220,.10)':'rgba(255,255,255,.55)');lg.addColorStop(1,'rgba(255,255,255,0)');
  c.fillStyle=lg;c.fillRect(0,0,w,h);
  // plaster grain
  const n=Math.min(9000,(w*h)/55);
  for(let i=0;i<n;i++){c.fillStyle=R()<.5?'rgba(0,0,0,.035)':'rgba(255,255,255,.05)';c.fillRect(R()*w,R()*h,1+R()*1.5,1+R()*1.5)}
  const f=a.form||'ribbon';
  if(f==='ribbon') ribbon(c,w,h,R,pal,a);
  else if(f==='sconce'){glow(c,w*.5,h*.5,Math.min(w,h)*.55,pal);ribbon(c,w,h,R,pal,{...a,box:[.28,.22,.72,.78],w:1.5})}
  else if(f==='tassel'){if(a.glow)glow(c,w*.5,h*.4,Math.min(w,h)*.5,PAL.pink);const pts=ribbon(c,w,h,R,pal,{...a,box:[.12,.12,.88,.55]});tassels(c,w,h,R,pts,a.pal==='gold')}
  else if(f==='vessel') vessel(c,w,h,R,pal,a);
  else if(f==='chandelier') chandelier(c,w,h,R,pal);
  else if(f==='box') sampleBox(c,w,h,R);
  else if(f==='visit') visit(c,w,h,R);
  else if(f==='portrait') portrait(c,w,h,R,pal,a);
  return true;
}
function glow(c,x,y,rad,pal){const g=c.createRadialGradient(x,y,0,x,y,rad);g.addColorStop(0,hsl(pal.h,70,78,.55));g.addColorStop(.5,hsl(38,90,70,.18));g.addColorStop(1,'rgba(0,0,0,0)');c.fillStyle=g;c.fillRect(x-rad,y-rad,rad*2,rad*2)}
function bez(p0,p1,p2,p3,t){const u=1-t;return[u*u*u*p0[0]+3*u*u*t*p1[0]+3*u*t*t*p2[0]+t*t*t*p3[0],u*u*u*p0[1]+3*u*u*t*p1[1]+3*u*t*t*p2[1]+t*t*t*p3[1]]}
function ribbon(c,w,h,R,pal,a){
  const bx=a.box||[.06,.06,.94,.94];
  const X=v=>w*(bx[0]+(bx[2]-bx[0])*v), Y=v=>h*(bx[1]+(bx[3]-bx[1])*v);
  const vert=(h*(bx[3]-bx[1]))>(w*(bx[2]-bx[0]))*1.1;
  const p0=vert?[X(.3+R()*.4),Y(.04)]:[X(.04),Y(.3+R()*.4)], p3=vert?[X(.3+R()*.4),Y(.96)]:[X(.96),Y(.3+R()*.4)];
  const p1=[X(R()),Y(R())], p2=[X(R()),Y(R())];
  const S=Math.min(w*(bx[2]-bx[0]),h*(bx[3]-bx[1])), W=S*(.24+R()*.1)*(a.w||1);
  const N=260, f1=9+R()*9, ph=R()*6.28, f2=1.5+R()*2.5, ph2=R()*6.28;
  const pts=[];
  for(let i=0;i<=N;i++){
    const t=i/N, p=bez(p0,p1,p2,p3,t), q=bez(p0,p1,p2,p3,Math.min(1,t+.002)), q0=bez(p0,p1,p2,p3,Math.max(0,t-.002));
    let dx=q[0]-q0[0], dy=q[1]-q0[1]; const L=Math.hypot(dx,dy)||1; dx/=L; dy/=L;
    const nx=-dy, ny=dx, th=f1*t*6.28/3+ph;
    const taper=Math.min(1,t/.06,(1-t)/.06), amp=(.65+.35*Math.sin(f2*t*6.28+ph2))*taper;
    const off=W*.18*Math.sin(f2*t*4+ph2);
    pts.push({x:p[0]+nx*off,y:p[1]+ny*off,nx,ny,hw:W/2*Math.cos(th)*amp,th});
  }
  // soft cast shadow
  c.save();c.shadowColor=a.dark?'rgba(0,0,0,.55)':'rgba(60,30,30,.28)';c.shadowBlur=S*.06;c.shadowOffsetX=10000+S*.035;c.shadowOffsetY=S*.05;
  c.strokeStyle='#000';c.lineWidth=W*.55;c.lineCap='round';c.lineJoin='round';c.beginPath();
  pts.forEach((p,i)=>i?c.lineTo(p.x-10000,p.y):c.moveTo(p.x-10000,p.y));c.stroke();c.restore();
  // surface
  for(let i=0;i<N;i++){
    const A=pts[i],B=pts[i+1];
    const lit=Math.max(0,Math.sin(A.th+.9)), back=Math.cos(A.th)<0;
    let L,s=pal.s,alpha=1;
    if(pal.k==='chrome'){L=14+Math.pow(lit,1.4)*84+10*Math.sin(A.th*3);s=4}
    else if(pal.k==='metal'){L=pal.l-18+Math.pow(lit,1.3)*46;}
    else if(pal.k==='gloss'){L=pal.l-10+lit*26+(lit>.94?28:0)}
    else if(pal.k==='frost'){L=pal.l-8+lit*18;alpha=.86}
    else {L=pal.l-9+lit*16}
    if(back) L-=7;
    c.fillStyle=c.strokeStyle=hsl(pal.h,s,L,alpha);c.lineWidth=.7;
    c.beginPath();c.moveTo(A.x+A.nx*A.hw,A.y+A.ny*A.hw);c.lineTo(B.x+B.nx*B.hw,B.y+B.ny*B.hw);c.lineTo(B.x-B.nx*B.hw,B.y-B.ny*B.hw);c.lineTo(A.x-A.nx*A.hw,A.y-A.ny*A.hw);c.closePath();c.fill();c.stroke();
  }
  // edge highlight
  c.strokeStyle=pal.k==='chrome'?'rgba(255,255,255,.55)':'rgba(255,255,255,.22)';c.lineWidth=1;c.beginPath();
  pts.forEach((p,i)=>{const x=p.x+p.nx*p.hw,y=p.y+p.ny*p.hw;i?c.lineTo(x,y):c.moveTo(x,y)});c.stroke();
  return pts;
}
function tassels(c,w,h,R,pts,gold){
  const k=5;
  for(let i=0;i<k;i++){
    const p=pts[Math.floor((i+.5)/k*pts.length)]; const len=h*(.18+R()*.12), top=p.y+4;
    c.strokeStyle=gold?'#C9A65A':'#A7907A';c.lineWidth=1.4;c.beginPath();c.moveTo(p.x,top);c.lineTo(p.x,top+len*.4);c.stroke();
    c.fillStyle=gold?'#B8913F':'#8C6E52';c.beginPath();c.ellipse(p.x,top+len*.42,4,6,0,0,6.3);c.fill();
    for(let j=0;j<16;j++){c.strokeStyle=gold?`hsla(42,55%,${55+R()*20}%,.9)`:`hsla(30,25%,${55+R()*20}%,.9)`;c.lineWidth=.9;c.beginPath();c.moveTo(p.x+(R()-.5)*4,top+len*.47);c.quadraticCurveTo(p.x+(R()-.5)*10,top+len*.75,p.x+(R()-.5)*12,top+len);c.stroke()}
  }
}
function vessel(c,w,h,R,pal,a){
  const cx=w/2, base=h*.8, bw=Math.min(w,h)*(a.tall?.34:.62), bh=Math.min(w,h)*(a.tall?.7:.42), top=base-bh;
  c.save();c.shadowColor='rgba(40,20,20,.3)';c.shadowBlur=24;c.shadowOffsetY=10;
  c.fillStyle=hsl(0,0,0,.2);c.beginPath();c.ellipse(cx,base+4,bw*.45,bw*.08,0,0,6.3);c.fill();c.restore();
  const g=c.createLinearGradient(cx-bw/2,0,cx+bw/2,0);
  g.addColorStop(0,hsl(pal.h,pal.s,pal.l-12));g.addColorStop(.32,hsl(pal.h,pal.s,pal.l+14));g.addColorStop(.42,hsl(pal.h,pal.s-10,pal.l+34));g.addColorStop(1,hsl(pal.h,pal.s,pal.l-16));
  c.fillStyle=g;c.beginPath();
  if(a.tall){c.moveTo(cx-bw*.22,base);c.bezierCurveTo(cx-bw*.8,base-bh*.4,cx-bw*.1,top+bh*.3,cx-bw*.35,top);c.lineTo(cx+bw*.35,top);c.bezierCurveTo(cx+bw*.1,top+bh*.3,cx+bw*.8,base-bh*.4,cx+bw*.22,base);}
  else{c.moveTo(cx-bw/2,top);c.bezierCurveTo(cx-bw/2,base-bh*.1,cx-bw*.22,base,cx,base);c.bezierCurveTo(cx+bw*.22,base,cx+bw/2,base-bh*.1,cx+bw/2,top);}
  c.closePath();c.fill();
  // folded rim
  const rw=a.tall?bw*.35:bw/2;c.fillStyle=hsl(pal.h,pal.s,pal.l-20);c.beginPath();
  for(let i=0;i<=60;i++){const t=i/60*6.283;const rr=1+.08*Math.sin(t*5+R());const x=cx+Math.cos(t)*rw*rr,y=top+Math.sin(t)*rw*.22*rr;i?c.lineTo(x,y):c.moveTo(x,y)}
  c.closePath();c.fill();
  c.strokeStyle=hsl(pal.h,pal.s,pal.l+20,.8);c.lineWidth=1.4;c.stroke();
}
function chandelier(c,w,h,R,pal){
  [[.28,.22,.52,.42],[.46,.38,.86,.62],[.06,.5,.4,.72]].forEach((b,i)=>{
    const cx=w*(b[0]+b[2])/2;c.strokeStyle='rgba(255,255,255,.35)';c.lineWidth=1;c.beginPath();c.moveTo(cx,0);c.lineTo(cx,h*b[1]+8);c.stroke();
    glow(c,cx,h*(b[1]+b[3])/2,w*.22,{h:38});
    ribbon(c,w,h,R,pal,{box:b,w:1.2,dark:1});
  });
}
function sampleBox(c,w,h,R){
  const S=Math.min(w,h), bw=S*.86, bh=S*.62, x=(w-bw)/2, y=(h-bh)/2;
  c.save();c.shadowColor='rgba(50,30,20,.3)';c.shadowBlur=20;c.shadowOffsetY=8;c.fillStyle='#C9A983';c.fillRect(x,y,bw,bh);c.restore();
  c.fillStyle='#E7DCCB';c.fillRect(x+8,y+8,bw-16,bh-16);
  const cols=['#7A2234','#C9BCB0','#E7A3B6','#1E1A1B','#9FC7BA','#B5583B'], gx=3, gy=2, pad=bw*.06, cw=(bw-16-pad*(gx+1))/gx, ch=(bh-16-pad*(gy+1))/gy;
  cols.forEach((col,i)=>{const cx=x+8+pad+(i%gx)*(cw+pad), cy=y+8+pad+Math.floor(i/gx)*(ch+pad);
    c.fillStyle=col;c.beginPath();c.roundRect?c.roundRect(cx,cy,cw,ch,8):c.rect(cx,cy,cw,ch);c.fill();
    const hl=c.createLinearGradient(cx,cy,cx+cw,cy+ch);hl.addColorStop(0,'rgba(255,255,255,.35)');hl.addColorStop(.5,'rgba(255,255,255,0)');c.fillStyle=hl;c.fill()});
  c.fillStyle='#5B4632';c.font=`700 ${Math.max(9,S*.04)}px Manrope, sans-serif`;c.fillText('FORMR · TRADE SAMPLES',x+12,y+bh-6);
}
function visit(c,w,h,R){
  c.strokeStyle='rgba(60,40,40,.55)';c.setLineDash([5,5]);c.lineWidth=1.4;
  const x=w*.18,y=h*.2,bw=w*.64,bh=h*.6;c.strokeRect(x,y,bw,bh);c.setLineDash([]);
  ribbon(c,w,h,R,PAL.burgundy,{box:[.24,.27,.76,.73],w:.9});
  c.strokeStyle='rgba(60,40,40,.7)';c.lineWidth=1;c.beginPath();c.moveTo(x,y-10);c.lineTo(x+bw,y-10);c.moveTo(x,y-15);c.lineTo(x,y-5);c.moveTo(x+bw,y-15);c.lineTo(x+bw,y-5);c.stroke();
  c.fillStyle='rgba(60,40,40,.85)';c.font=`600 ${Math.max(9,Math.min(w,h)*.045)}px Manrope, sans-serif`;c.textAlign='center';c.fillText('1200 mm',x+bw/2,y-14);c.textAlign='left';
}
function portrait(c,w,h,R,pal,a){
  for(let i=0;i<7;i++){c.strokeStyle=hsl(pal.h,pal.s,pal.l-10+R()*24,.55);c.lineWidth=h*(.08+R()*.1);c.lineCap='round';c.beginPath();
    const y=h*(.15+R()*.7);c.moveTo(-20,y);c.bezierCurveTo(w*.3,y-h*.2*R(),w*.7,y+h*.2*R(),w+20,y-h*.1);c.stroke()}
  c.fillStyle='rgba(255,255,255,.92)';c.font=`800 ${w*.34}px "Bricolage Grotesque", sans-serif`;c.textAlign='center';c.textBaseline='middle';c.fillText(a.init||'',w/2,h*.52);
  c.textAlign='left';c.textBaseline='alphabetic';
}

/* ---------- cursor + paint splatter ---------- */
const brush=(tip)=>`<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"><g stroke-linecap="round"><path d="M31 3 18.5 15.5" stroke="#fff" stroke-width="6"/><path d="M31 3 18.5 15.5" stroke="#2A1F22" stroke-width="3.4"/><path d="M18 13.6l2.4 2.4-3 3-2.4-2.4z" fill="#B9B4AE" stroke="#fff" stroke-width="1"/><path d="M15 16.6l2.4 2.4c-1.2 3.4-5 7.3-10.5 11.6-1.6 1.2-3.6 2-4.4 1.6-.3-.8.5-2.6 1.8-4.2C8 22.8 11.6 18.6 15 16.6z" fill="${tip}" stroke="#fff" stroke-width="1.2"/></g></svg>`;
const curUrl=(s,fb)=>`url("data:image/svg+xml,${encodeURIComponent(s)}") 2 32, ${fb}`;
if(F.cursor!==false&&matchMedia('(hover:hover) and (pointer:fine)').matches){
  document.documentElement.style.setProperty('--cur',curUrl(brush('#7A2234'),'auto'));
  document.documentElement.style.setProperty('--cur2',curUrl(brush('#D0657A'),'pointer'));
}
const SPLAT=['#7A2234','#1E1719','#C9A14A','#8FB8AC','#B5583B','#D98AA0'];
function splat(x,y){
  const r=Math.random, col=SPLAT[Math.floor(r()*SPLAT.length)], ns='http://www.w3.org/2000/svg';
  const s=document.createElementNS(ns,'svg');s.setAttribute('viewBox','-65 -65 130 130');s.setAttribute('class','splat');s.style.left=x+'px';s.style.top=y+'px';
  let d='';const k=14;for(let i=0;i<=k;i++){const t=i/k*6.283, rr=13+r()*9+(i%3===0?r()*10:0);d+=(i?'L':'M')+(Math.cos(t)*rr).toFixed(1)+','+(Math.sin(t)*rr).toFixed(1)}
  let html=`<path d="${d}Z" fill="${col}" stroke="${col}" stroke-width="6" stroke-linejoin="round"/>`;
  for(let i=0;i<12;i++){const t=r()*6.283, dist=26+r()*32, rad=1.2+r()*4.2;html+=`<circle cx="${(Math.cos(t)*dist).toFixed(1)}" cy="${(Math.sin(t)*dist).toFixed(1)}" r="${rad.toFixed(1)}" fill="${col}"/>`}
  for(let i=0;i<3;i++){const t=r()*360;html+=`<ellipse cx="0" cy="${-(30+r()*14)}" rx="2.4" ry="${8+r()*8}" fill="${col}" transform="rotate(${t.toFixed(0)})"/>`}
  s.innerHTML=html;document.body.appendChild(s);
  const an=s.animate(reduce?[{opacity:.8},{opacity:0}]:[{transform:'scale(.15) rotate(0deg)',opacity:1},{transform:`scale(1) rotate(${(r()*40-20).toFixed(0)}deg)`,opacity:.95,offset:.18},{transform:'scale(1.05)',opacity:0}],{duration:reduce?400:950,easing:'cubic-bezier(.2,.8,.2,1)'});
  an.onfinish=()=>s.remove();
}
document.addEventListener('pointerdown',e=>{if(F.splatter===false||e.button>0)return;if(e.target.closest('a,button,.tile,canvas.art,img,summary,label,.chip,[data-qv]'))splat(e.clientX,e.clientY)},{passive:true});


/* ---------- lazy drawing of placeholder art ---------- */
const drawn=new WeakSet();
const io=('IntersectionObserver' in window)?new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting&&!drawn.has(e.target)){if(drawArt(e.target))drawn.add(e.target)}}),{rootMargin:'400px'}):null;
function watch(cv){if(io)io.observe(cv);else if(drawArt(cv))drawn.add(cv)}
function artCanvas(a,label){const cv=document.createElement('canvas');cv.className='art';cv.dataset.a=JSON.stringify(a);if(label){cv.setAttribute('role','img');cv.setAttribute('aria-label',label)}else cv.setAttribute('aria-hidden','true');watch(cv);return cv}
function initArt(root){$$('canvas.art',root).forEach(watch)}
let rz;addEventListener('resize',()=>{clearTimeout(rz);rz=setTimeout(()=>$$('canvas.art').forEach(cv=>{if(drawn.has(cv)&&cv.offsetParent)drawArt(cv)}),250)});
if(document.fonts)document.fonts.ready.then(()=>$$('canvas.art').forEach(cv=>{if(drawn.has(cv)&&/portrait|box|visit/.test(cv.dataset.a||''))drawArt(cv)}));

/* ---------- menu ---------- */
function initMenu(){
  const m=$('#menu'),b=$('#menuBtn'),c=$('#menuClose');if(!m||!b)return;
  b.onclick=()=>{m.classList.add('open');m.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';c&&c.focus()};
  const close=()=>{m.classList.remove('open');m.setAttribute('aria-hidden','true');document.body.style.overflow=''};
  c&&(c.onclick=close);$$('a',m).forEach(a=>a.addEventListener('click',close));
}

/* ---------- hero slider ---------- */
const editing=()=>!!(window.Shopify&&Shopify.designMode);
function initHero(root){
  $$('[data-hero]',root||document).forEach(hero=>{
    if(hero._hero)return;
    const slides=$$('.slide',hero),dots=$('.dots',hero);
    if(!slides.length)return;
    let si=Math.max(0,slides.findIndex(s=>s.classList.contains('on'))),timer;
    const speed=(+hero.dataset.speed||6)*1000;
    function go(i,user){
      slides.forEach(s=>{s.classList.remove('on');s.setAttribute('aria-hidden','true')});
      si=(i+slides.length)%slides.length;slides[si].classList.add('on');slides[si].removeAttribute('aria-hidden');
      if(dots)$$('button',dots).forEach((b,j)=>b.toggleAttribute('aria-current',j===si));
      $$('canvas.art',slides[si]).forEach(cv=>{if(!drawn.has(cv)&&drawArt(cv))drawn.add(cv)});
      if(user)restart();
    }
    function restart(){clearInterval(timer);if(!reduce&&!editing()&&slides.length>1)timer=setInterval(()=>go(si+1),speed)}
    if(dots){dots.innerHTML='';if(slides.length>1)slides.forEach((s,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Show slide '+(i+1));b.onclick=()=>go(i,true);dots.appendChild(b)})}
    hero._hero={go,stop:()=>clearInterval(timer),slides};
    go(si);restart();
    let sx=null;hero.addEventListener('touchstart',e=>sx=e.touches[0].clientX,{passive:true});
    hero.addEventListener('touchend',e=>{if(sx==null||slides.length<2)return;const dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>45)go(si+(dx<0?1:-1),true);sx=null});
    hero.addEventListener('mouseenter',()=>clearInterval(timer));hero.addEventListener('mouseleave',restart);
  });
}
/* in the theme editor, keep showing the slide being edited */
let editBlock=null;
function showEditedSlide(target){
  const hero=target&&target.closest&&target.closest('[data-hero]');if(!hero||!hero._hero)return;
  const i=hero._hero.slides.indexOf(target.closest('.slide'));if(i>-1){hero._hero.stop();hero._hero.go(i)}
}
document.addEventListener('shopify:block:select',e=>{editBlock=e.detail&&e.detail.blockId;showEditedSlide(e.target)});
document.addEventListener('shopify:block:deselect',()=>{editBlock=null});

/* ---------- reveal on scroll ---------- */
const rio=('IntersectionObserver' in window)?new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('pre');e.target.classList.add('in');rio.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px'}):null;
function revealScan(root){
  const els=$$('.rv:not(.seen), .tile:not(.seen), [data-map]:not(.seen)',root||document);
  els.forEach(el=>{
    el.classList.add('seen');
    if(!rio||reduce||window.Shopify&&Shopify.designMode){el.classList.add('in');return}
    if(el.getBoundingClientRect().top<innerHeight*.92){el.classList.add('in');return}
    el.classList.add('pre');
    if(el.classList.contains('tile'))el.style.transitionDelay=((Array.prototype.indexOf.call(el.parentNode.children,el)%4)*.09)+'s';
    rio.observe(el);
  });
}

/* ---------- map trails ---------- */
function initMap(){
  const C={Sydney:[352.8,240.6],Melbourne:[296.6,280.3],Adelaide:[239.4,251.3],Perth:[34.7,221.3],Darwin:[169.6,24.8],Hobart:[318,331.4],Cairns:[303.9,69.8]};
  const B=[369.3,176.1],ns='http://www.w3.org/2000/svg';
  $$('[data-map]').forEach(map=>{
    const tr=$('[data-trails]',map),ci=$('[data-cities]',map);if(!tr||tr.childNodes.length)return;
    Object.entries(C).forEach(([n,[x,y]],i)=>{
      const mx=(B[0]+x)/2,my=(B[1]+y)/2-Math.hypot(x-B[0],y-B[1])*.25;
      const p=document.createElementNS(ns,'path');p.setAttribute('d',`M${B[0]},${B[1]}Q${mx},${my} ${x},${y}`);p.setAttribute('class','trail');tr.appendChild(p);
      const len=p.getTotalLength?Math.ceil(p.getTotalLength()):600;p.style.setProperty('--len',len);p.style.transitionDelay=(i*.12)+'s';
      const c=document.createElementNS(ns,'circle');c.setAttribute('cx',x);c.setAttribute('cy',y);c.setAttribute('r',3.2);c.setAttribute('class','city');ci.appendChild(c);
      const t=document.createElementNS(ns,'text');t.setAttribute('class','ctext');const right=x<200;t.setAttribute('x',x+(right?7:-7));t.setAttribute('y',y+3.5);t.setAttribute('text-anchor',right?'start':'end');t.textContent=n;ci.appendChild(t);
    });
    map.classList.add('map');
  });
}

/* ---------- overlay helpers ---------- */
let lastFocus=null;
const ov=()=>$('#ov');
function openSheet(el){if(!el)return;lastFocus=document.activeElement;el.classList.add('open');el.setAttribute('aria-hidden','false');ov()&&ov().classList.add('open');document.body.style.overflow='hidden';setTimeout(()=>{const f=el.querySelector('.x');f&&f.focus()},60)}
function closeAll(){$$('.sheet.open').forEach(el=>{el.classList.remove('open');el.setAttribute('aria-hidden','true')});ov()&&ov().classList.remove('open');closeLb();document.body.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});lastFocus=null}
document.addEventListener('click',e=>{if(e.target.closest('[data-close]')||e.target.id==='ov')closeAll()});
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll();const lb=$('#lb');if(lb&&lb.classList.contains('open')){if(e.key==='ArrowRight')lbGo(1);if(e.key==='ArrowLeft')lbGo(-1)}});

/* ---------- cart drawer (Shopify AJAX API) ---------- */
const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
async function getCart(){const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});return r.json()}
function renderCart(cart){
  const n=cart.item_count,cc=$('#cartCount');
  if(cc){cc.textContent=n;cc.dataset.n=n}
  const cb=$('#cartBtn');cb&&cb.setAttribute('aria-label',`Cart, ${n} item${n===1?'':'s'}`);
  const L=$('#lines');if(!L)return;L.innerHTML='';
  if(!n){L.innerHTML='<p class="empty">Your cart is empty. Every piece here is made by hand in Brisbane.</p>'}
  cart.items.forEach((it,i)=>{
    const d=document.createElement('div');d.className='line';
    const th=document.createElement('a');th.className='th';th.href=it.url;
    if(it.image){const im=new Image();im.src=it.image+(it.image.includes('?')?'&':'?')+'width=200';im.alt='';im.loading='lazy';th.appendChild(im)}else th.appendChild(artCanvas({seed:it.product_id%97+3,pal:'greige'}));
    d.appendChild(th);
    const m=document.createElement('div');
    const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    let props='';if(it.properties)Object.entries(it.properties).forEach(([k,v])=>{if(v&&k[0]!=='_')props+=`<small>${esc(k)}: ${esc(v)}</small>`});
    m.innerHTML=`<b>${esc(it.product_title)}</b>${it.variant_title&&!it.product_has_only_default_variant?`<small>${esc(it.variant_title)}</small>`:''}${props}<div class="qty"><button type="button" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" aria-label="Increase">+</button></div>`;
    const [mi,pl]=$$('button',m);mi.onclick=()=>change(i+1,it.quantity-1);pl.onclick=()=>change(i+1,it.quantity+1);
    d.appendChild(m);const pr=document.createElement('b');pr.textContent=money(it.final_line_price);pr.style.fontVariantNumeric='tabular-nums';d.appendChild(pr);L.appendChild(d);
  });
  const sub=$('#sub');sub&&(sub.textContent=money(cart.total_price));
  const cp=$('#cartP4');cp&&(cp.innerHTML=n?p4(cart.total_price):'');
  const co=$('#checkout');co&&co.toggleAttribute('hidden',!n);
}
async function change(line,quantity){
  const r=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});
  renderCart(await r.json());
}
function initCart(){
  const btn=$('#cartBtn');
  if(btn&&$('#cart')&&!document.body.classList.contains('template-cart')){
    btn.addEventListener('click',async e=>{e.preventDefault();openSheet($('#cart'));try{renderCart(await getCart())}catch(err){location.href=btn.href}});
  }
  document.addEventListener('submit',async e=>{
    const f=e.target.closest('form[data-ajax-cart]');if(!f)return;
    const err=$('[data-form-err]',f);
    const missing=$$('[required]',f).find(x=>!x.value.trim());
    if(missing){e.preventDefault();if(err)err.textContent='Please fill in '+(f.querySelector(`label[for="${missing.id}"]`)||{textContent:'the required fields'}).textContent.replace(' *','').toLowerCase()+'.';missing.focus();return}
    e.preventDefault();
    const b=f.querySelector('[type=submit]');b&&(b.disabled=true);
    try{
      const r=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});
      const j=await r.json();
      if(!r.ok){if(err)err.textContent=j.description||'That piece could not be added. Please try again.';else toast(j.description||'Could not add to cart');return}
      if(err)err.textContent='';
      renderCart(await getCart());
      if(btn&&!reduce)btn.animate([{transform:'rotate(0)'},{transform:'rotate(-14deg)'},{transform:'rotate(10deg)'},{transform:'rotate(0)'}],{duration:500});
      openSheet($('#cart'));
    }catch(x){f.submit()}finally{b&&(b.disabled=false)}
  });
}

/* ---------- product page ---------- */
function initProduct(){
  $$('[data-product]').forEach(sec=>{
    const vEl=$('[data-variants]',sec);const variants=vEl?JSON.parse(vEl.textContent):[];
    const idInput=$('[data-variant-id]',sec),priceEl=$('[data-price]',sec),p4El=$('.pdp-info [data-p4]',sec),add=$('[data-add]',sec);
    const showMedia=id=>{if(!id)return;const s=$(`.pdp-slide[data-media-id="${id}"]`,sec);if(!s)return;$$('.pdp-slide',sec).forEach(x=>x.classList.toggle('on',x===s));$$('.thumb',sec).forEach(t=>t.classList.toggle('on',t.dataset.thumb==String(id)))};
    $$('.thumb',sec).forEach(t=>t.onclick=()=>showMedia(t.dataset.thumb));
    const radios=$$('input[data-opt]',sec);
    const update=()=>{
      const sel=[];radios.forEach(r=>{if(r.checked)sel[+r.dataset.opt]=r.value});
      const v=variants.find(v=>v.options.every((o,i)=>sel[i]===undefined||o===sel[i]));
      if(!v){if(add){add.disabled=true;add.textContent='Unavailable'}return}
      idInput.value=v.id;
      priceEl.innerHTML=money(v.price)+(v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:'');
      if(p4El)p4El.innerHTML=p4(v.price);
      if(add){add.disabled=!v.available;add.textContent=v.available?(add.dataset.label||add.textContent.trim()):'Sold out'}
      if(v.featured_media)showMedia(v.featured_media.id);
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
    };
    if(add)add.dataset.label=add.textContent.trim()==='Sold out'?'Add to cart':add.textContent.trim();
    radios.forEach(r=>r.addEventListener('change',update));
    $$('[data-q]',sec).forEach(b=>b.onclick=()=>{const i=b.parentNode.querySelector('input');i.value=Math.max(1,(+i.value||1)+(+b.dataset.q))});
    $$('[data-zoom]',sec).forEach(z=>z.onclick=()=>openLb([{full:z.dataset.zoom,title:document.querySelector('.pdp-title').textContent,sub:''}],0,true));
  });
}

/* ---------- gallery lightbox ---------- */
let lbList=[],lbI=0;
function initGallery(){
  $$('[data-gallery]').forEach(g=>{
    const tiles=$$('.tile',g);
    const list=tiles.map(t=>({full:t.dataset.full,title:t.dataset.title||'',sub:t.dataset.sub||'',a:(t.querySelector('canvas.art')||{}).dataset}));
    tiles.forEach((t,i)=>t.addEventListener('click',()=>openLb(list,i)));
  });
  const lb=$('#lb');if(!lb)return;
  $('#lbClose').onclick=()=>{closeLb();lastFocus&&lastFocus.focus()};$('#lbPrev').onclick=()=>lbGo(-1);$('#lbNext').onclick=()=>lbGo(1);
  let lx=null;lb.addEventListener('touchstart',e=>lx=e.touches[0].clientX,{passive:true});
  lb.addEventListener('touchend',e=>{if(lx==null)return;const dx=e.changedTouches[0].clientX-lx;if(Math.abs(dx)>45)lbGo(dx<0?1:-1);lx=null});
}
function openLb(list,i,single){const lb=$('#lb');if(!lb)return;lbList=list;lbI=i;lastFocus=document.activeElement;lbShow();lb.classList.add('open');lb.setAttribute('aria-hidden','false');lb.classList.toggle('single',!!single||list.length<2);document.body.style.overflow='hidden';$('#lbClose').focus()}
function lbShow(){
  const g=lbList[lbI],st=$('#lbStage');$$('canvas,img',st).forEach(x=>x.remove());
  if(g.full){const im=new Image();im.src=g.full;im.alt=g.title;st.insertBefore(im,st.firstChild)}
  else if(g.a&&g.a.a){const vw=Math.min(innerWidth-32,900),vh=innerHeight*.66;let w=vw,h=w*1.25;if(h>vh){h=vh;w=h/1.25}
    const cv=document.createElement('canvas');cv.className='art';cv.style.width=w+'px';cv.style.height=h+'px';cv.dataset.a=g.a.a;cv.setAttribute('role','img');cv.setAttribute('aria-label',g.title);st.insertBefore(cv,st.firstChild);requestAnimationFrame(()=>drawArt(cv))}
  $('#lbTitle').textContent=g.title;$('#lbSub').textContent=g.sub;$('#lbCount').textContent=lbList.length>1?(lbI+1)+' / '+lbList.length:'';
  $('#lbPrev').hidden=$('#lbNext').hidden=lbList.length<2;
  const cta=$('#lbCta');cta.onclick=()=>{closeLb();setPrefill(g.title?'I’d love something like '+g.title+'.':'')};
}
function lbGo(d){if(lbList.length<2)return;lbI=(lbI+d+lbList.length)%lbList.length;lbShow()}
function closeLb(){const lb=$('#lb');if(!lb||!lb.classList.contains('open'))return;lb.classList.remove('open');lb.setAttribute('aria-hidden','true');document.body.style.overflow=''}

/* ---------- enquiry form ---------- */
function setPrefill(msg){try{if(msg)sessionStorage.setItem('formr-prefill',msg)}catch(e){}}
function initEnquiry(){
  document.addEventListener('click',e=>{const p=e.target.closest('[data-prefill]');if(p)setPrefill(p.dataset.prefill)});
  let pre=null;try{pre=sessionStorage.getItem('formr-prefill');sessionStorage.removeItem('formr-prefill')}catch(e){}
  $$('form[data-enquiry]').forEach(f=>{
    const msg=$('[data-enquiry-msg]',f);if(pre&&msg&&!msg.value)msg.value=pre;
    f.addEventListener('submit',e=>{
      const err=$('[data-enq-err]',f);if(!err)return;
      const name=f.querySelector('[name="contact[name]"]'),email=f.querySelector('[name="contact[email]"]'),phone=f.querySelector('[name="contact[phone]"]');
      const prefs=$$('[data-pref]',f).filter(x=>x.checked),needsPhone=prefs.some(x=>x.hasAttribute('data-needs-phone'));
      let m='';
      if(!name.value.trim()){m='Please add your name.';name.focus()}
      else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())){m='Please check your email address, for example name@email.com.';email.focus()}
      else if(!prefs.length)m='Choose at least one way for us to contact you.';
      else if(needsPhone&&!phone.value.trim()){m='Add a phone number so we can call or text you.';phone.focus()}
      if(m){e.preventDefault();err.textContent=m}
    });
  });
  const done=$('.enq .done');if(done){done.scrollIntoView({block:'center'});done.focus({preventScroll:true})}
}

/* ---------- collection sort ---------- */
function initSort(){$$('[data-sort]').forEach(s=>s.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u}))}

/* ---------- floating button ---------- */
function initFab(){
  const fab=$('#fab');if(!fab||!('IntersectionObserver' in window))return;
  const vis=new Set();const fio=new IntersectionObserver(es=>{es.forEach(e=>e.isIntersecting?vis.add(e.target):vis.delete(e.target));fab.classList.toggle('hide',vis.size>0)});
  [...$$('form[data-enquiry]'),$('footer.site')].filter(Boolean).forEach(el=>fio.observe(el));
}

function toast(t){const el=$('#toast');if(!el)return;el.textContent=t;el.classList.add('on');clearTimeout(el._t);el._t=setTimeout(()=>el.classList.remove('on'),3800)}

function init(root){initArt(root);revealScan(root);initMap()}
document.addEventListener('DOMContentLoaded',()=>{
  initMenu();initHero();init(document);initCart();initProduct();initGallery();initEnquiry();initSort();initFab();
});
/* theme editor support */
document.addEventListener('shopify:section:load',e=>{
  init(e.target);initHero(e.target);initGallery();initProduct();
  if(editBlock){const el=e.target.querySelector('[data-shopify-editor-block*="'+editBlock+'"]');if(el)showEditedSlide(el)}
});
})();
